import {ChangeDetectionStrategy, Component, computed} from "@angular/core"
import {ToggleComponent} from "@common/components/buttons/toggle/toggle.component"
import {OperatorShift} from "@app/textures/texture-editor/operator-stack/operators/shift/operator-shift"
import {InspectorSectionComponent} from "@template-editor/components/inspectors/inspector-section/inspector-section.component"
import {OperatorPanelBase} from "@app/textures/texture-editor/operator-stack/operators/abstract-base/operator-panel-base"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-shift-panel",
    templateUrl: "./shift-panel.component.html",
    styleUrls: ["./shift-panel.component.scss"],
    imports: [InspectorSectionComponent, ToggleComponent],
})
export class ShiftPanelComponent extends OperatorPanelBase<OperatorShift> {
    readonly $showGuides = computed(() => this.$operator().$showGuides())

    protected setShowGuides(value: boolean) {
        this.$operator().setShowGuides(value)
    }
}
